import { Check } from "lucide-react";

const YNU = [{ value: "yes", label: "Yes" }, { value: "no", label: "No" }, { value: "unsure", label: "Not sure" }];

function Choice({ selected, onClick, children, role, testId }) {
  return (
    <button
      type="button" role={role} aria-checked={selected} onClick={onClick} data-testid={testId}
      className={`flex min-h-[52px] w-full items-center gap-3 rounded-xl border-2 px-4 py-3 text-left text-lg transition-colors duration-150 focus:outline-none focus-visible:ring-4 focus-visible:ring-sky-400 ${selected ? "border-zinc-900 bg-zinc-900 text-white" : "border-zinc-300 bg-white text-zinc-900 hover:border-zinc-500"}`}
    >
      <span className={`flex h-6 w-6 flex-shrink-0 items-center justify-center border-2 ${role === "radio" ? "rounded-full" : "rounded-md"} ${selected ? "border-white" : "border-zinc-400"}`} aria-hidden="true">
        {selected && <Check className="h-4 w-4" />}
      </span>
      <span>{children}</span>
    </button>
  );
}

export function ChoiceList({ q, value, onChange, labelId }) {
  const options = q.type === "yes_no_unsure" ? YNU : q.options;
  if (q.type === "multi") {
    const cur = Array.isArray(value) ? value : [];
    const excl = q.exclusive || [];
    const toggle = (v) => {
      if (cur.includes(v)) return onChange(cur.filter((x) => x !== v));
      if (excl.includes(v)) return onChange([v]);
      onChange([...cur.filter((x) => !excl.includes(x)), v]);
    };
    return (
      <div className="space-y-2.5" role="group" aria-labelledby={labelId}>
        <p className="text-sm text-zinc-600">Choose all that apply.</p>
        {options.map((o) => (
          <Choice key={o.value} role="checkbox" selected={cur.includes(o.value)} onClick={() => toggle(o.value)} testId={`checkin-option-${q.code}-${o.value}`}>
            {o.label}
          </Choice>
        ))}
      </div>
    );
  }
  return (
    <div className="space-y-2.5" role="radiogroup" aria-labelledby={labelId}>
      {options.map((o) => (
        <Choice key={o.value} role="radio" selected={value === o.value} onClick={() => onChange(o.value)} testId={`checkin-option-${q.code}-${o.value}`}>
          {o.label}
        </Choice>
      ))}
    </div>
  );
}
